function normalizeDirectDealAdUnit(adUnit, fallbackId) {
  if (!adUnit || typeof adUnit !== 'object') {
    return adUnit;
  }

  const nestedAdUnit = adUnit.id && typeof adUnit.id === 'object' ? adUnit.id : null;
  if (!nestedAdUnit) {
    return adUnit;
  }

  return {
    ...adUnit,
    ...nestedAdUnit,
    id: nestedAdUnit.id ?? fallbackId ?? null,
    name: adUnit.name ?? nestedAdUnit.name,
  };
}

function normalizeDirectDeal(directDeal) {
  if (!directDeal || typeof directDeal !== 'object') {
    return directDeal;
  }

  return {
    ...directDeal,
    adUnit: normalizeDirectDealAdUnit(directDeal.adUnit, directDeal.adUnitId),
  };
}

export default {
  fetchPubSites: (function () {
    let cancelPubSitesFetching;
    return function ({ commit, state }, data = {}) {
      if (typeof cancelPubSitesFetching === 'function') {
        cancelPubSitesFetching();
      }
      const params = {
        params: {
          ...data.params,
        },
      };
      params.cancelToken = new this.$api.client.CancelToken(function executor(c) {
        cancelPubSitesFetching = c;
      });
      return this.$api.adnet
        .get('/ssp/sites', params)
        .then((res) => {
          const responseList = res.result === null ? [] : res.result;
          commit('SET_PUB_SITES', responseList);
          return res;
        })
        .catch((error) => {
          if (!this.$api.client.isCancel(error)) {
            throw error;
          }
        });
    };
  })(),
  fetchSiteLabels({ commit }) {
    return this.$api.adnet.get('/ssp/site-labels').then((res) => {
      const response = res.list === null ? [] : res.list;
      commit('SET_SITE_LABELS', response);
      return response;
    });
  },
  fetchSiteSettings({ commit, state }, refresh) {
    return this.$api.adnet.get(`/ssp/sites-settings`).then((res) => {
      const response = res.list === null ? [] : res.list;
      commit('SET_SITES_SETTINGS', response);
      return response;
    });
  },
  fetchAdunits({ commit, state }, data = {}) {
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/ssp/adunit', params).then((res) => {
      const response = res.result === null ? [] : res.result;
      const setter = data.noIds ? 'SET_ADUNITS_NO_IDS' : 'SET_ADUNITS';
      if (!data.noCommit) {
        commit(setter, response);
      }
      return res;
    });
  },
  fetchDirectDeals({ getters, commit }, data = {}) {
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/ssp/direct-deal', params).then((res) => {
      const response = Array.isArray(res.result) ? res.result.map(normalizeDirectDeal) : [];
      commit('SET_DIRECT_DEALS', response);
      return {
        ...res,
        result: response,
      };
    });
  },
  fetchSyndicationDomains({ commit, state }, data = {}) {
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/ssp/syndication-domain', params).then((res) => {
      const response = res.list === null ? [] : res.list;
      commit('SET_SYNDICATION_DOMAINS', response);
      return response;
    });
  },
  fetchBlacklistAutoRules({ commit, state }, data = {}) {
    const params = data.params ? data.params : { limit: 99999 };
    return this.$api.adnet.get(`/ssp/blacklist-auto-rules`, { params }).then((res) => {
      const response = res && res.result ? res.result : [];
      commit('SET_BLACKLIST_AUTO_RULES', response);
      return res;
    });
  },
};
